import { useLocation } from 'react-router-dom';
import { useHeaderAction } from '@/contexts/HeaderActionContext';

const routeTitles: Record<string, string> = {
  '/matches': 'Matches',
  '/matches/new': 'New Match',
  '/players': 'Players',
  '/teams': 'Teams',
  '/results': 'Results',
  '/settings': 'Settings',
};

export function Header() {
  const location = useLocation();
  const { action } = useHeaderAction();

  const getTitle = () => {
    // Check for exact match first
    if (routeTitles[location.pathname]) {
      return routeTitles[location.pathname];
    }

    // Check for dynamic routes
    if (location.pathname.startsWith('/matches/active/')) {
      return 'Active Match';
    }
    if (location.pathname.match(/^\/matches\/[^/]+$/)) {
      return 'Match Details';
    }

    return 'Belot Tracker';
  };

  return (
    <header className="sticky top-0 z-40 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 pt-safe">
      <div className="container flex h-14 items-center justify-between">
        <h1 className="text-lg font-semibold">{getTitle()}</h1>
        {action && <div>{action}</div>}
      </div>
    </header>
  );
}
